// Relative Imports
import { Container } from "./styles";

const Double = ({ children }) => {
  return <Container>{children}</Container>;
};

export default Double;
